import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ClientSearchModeContext = createContext({
    clientSearchOnly: false,
    /** False while AuthenticatedHome is resolving org login mode on `/`. */
    clientSearchModeResolved: true,
    setClientSearchMode: () => {},
});

function syncBodyDataset(searchOnly) {
    if (typeof document === 'undefined') return;
    if (searchOnly) {
        document.body.dataset.clientSearchOnly = '1';
    } else {
        delete document.body.dataset.clientSearchOnly;
    }
}

export function ClientSearchModeProvider({ children }) {
    const [clientSearchOnly, setClientSearchOnlyState] = useState(false);
    const [clientSearchModeResolved, setClientSearchModeResolved] = useState(true);

    const setClientSearchMode = useCallback(({ searchOnly, resolved }) => {
        if (resolved !== undefined) {
            setClientSearchModeResolved(Boolean(resolved));
        }
        if (searchOnly !== undefined) {
            const enabled = Boolean(searchOnly);
            setClientSearchOnlyState(enabled);
            syncBodyDataset(enabled);
        }
    }, []);

    const value = useMemo(
        () => ({ clientSearchOnly, clientSearchModeResolved, setClientSearchMode }),
        [clientSearchOnly, clientSearchModeResolved, setClientSearchMode],
    );

    return (
        <ClientSearchModeContext.Provider value={value}>
            {children}
        </ClientSearchModeContext.Provider>
    );
}

export function useClientSearchMode() {
    return useContext(ClientSearchModeContext);
}
